export class CriterioBusquedaObtenerDetalleDTO {
  numeroCuenta?: string;
  numeroCliente?: string;
  fechaInicio?: string;
  fechaFin?: string; 
  FechaUltimoMensaje 
}